import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { Observable, of } from 'rxjs';

import { ToastService } from 'src/app/services/toast.service';

import { MemberPaths } from 'src/app/constants/routes';
import { ToastType } from 'src/app/constants/toast-type';
import { EnrollmentManagerService } from '../services/enrollment-manager.service';

@Injectable()
export class BenefitEnrollmentGuard implements CanActivate {

    constructor(
        private enrollmentManagerService: EnrollmentManagerService,
        private toastService: ToastService,
        private router: Router,
    ) {
    }

    public canActivate(): Observable<boolean> {
        if (!this.enrollmentManagerService.manager) {
            this.toastService.buildToastMessage(ToastType.warning, 'Enrollment Process Denied!', 'Select an avalaible enrollment and attempt an enrollment again.');
            this.router.navigateByUrl(MemberPaths.BenefitsDashboard);
        }

        return of(!!this.enrollmentManagerService.manager);
    }
}